import { Col, Container, Row } from 'reactstrap';
import { shallowEqual, useSelector } from 'react-redux';
import PracticeDetails from './Practice/PracticeDetails';
import PracticeConfiguration from './Practice/PracticeConfiguration';
import PracticeLocations from './Practice/PracticeLocations/PracticeLocations';
import hasPermission from '../../Shared/hasPermission';
import './PracticeOverview.css';
import React from 'react';

// TODO: refactor the layout shenanigans here
const PracticeOverview = () => {
    const practiceId = useSelector((state) => state.practice.practice?.id);
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    // Practice Locations management is admin-only: PracticeLocationsController is
    // [Authorize(Policy = "BitwerxAdmin")], which resolves to the ViewAllPractices
    // claim. Gate the section on the same permission so partner roles (which carry
    // Configuration but not ViewAllPractices) don't render it and fire a GET that 403s.
    const canViewAllPractices = hasPermission('ViewAllPractices', permissions);

    return <Container className="mb-4">
            <Row className="d-none d-lg-flex">
                <PracticeDetails />
                <div
                    className="p-3 hover-parent-x sc-glass sc-shadow sc-rounded text-white ml-auto"
                    style={{ width: '49%' }}>
                    <PracticeConfiguration />
                </div>
            </Row>
            <Row className="d-lg-none">
                <Col
                    id="practiceInfo"
                    lg="6"
                    sm="12"
                    className="p-4 hover-parent sc-glass sc-shadow sc-rounded text-white">
                    <PracticeDetails />
                </Col>

                <Col id="separate-on-small-screens" sm="12">
                    &nbsp;
                </Col>

                <Col
                    id="datacoInfo"
                    lg="5"
                    sm="12"
                    className="p-4 hover-parent-x ml-auto text-light sc-glass sc-shadow sc-rounded">
                    <PracticeConfiguration />
                </Col>
            </Row>
            {canViewAllPractices && practiceId && (
                <Row className="mt-3">
                    <Col
                        sm="12"
                        className="p-4 sc-glass sc-shadow sc-rounded text-white">
                        <PracticeLocations practiceId={practiceId} />
                    </Col>
                </Row>
            )}
        </Container>;
};

export default React.memo(PracticeOverview);
